import framePage from '../framePage';

function showLoading($button) {
	framePage.allowSubmit = false;
	$button.addClass('loading').attr('aria-busy', true);
}

export default showLoading;
